import { Card, CardBody, Col } from "reactstrap";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { Image } from "../../../../AbstractElements";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { DisableTouchSwipings } from "../../../../Constant";
import { DISABLE_TOUCH, DISABLE_TOUCH_DATA } from "../../../../Data/Bonus Ui/Carousel";

const DisableTouchSwiping = () => {
  return (
    <Col xl="6" sm="12">
      <Card>
        <CommonCardHeader title={DisableTouchSwipings} span={DISABLE_TOUCH} />
        <CardBody>
          <Swiper modules={[Navigation]} navigation loop slidesPerView={1} simulateTouch={false}>
            {DISABLE_TOUCH_DATA?.map((item, index) => (
              <SwiperSlide key={index}>
                <Image src={item.image} alt="drawing-room" className="d-block w-100" />
              </SwiperSlide>
            ))}
          </Swiper>
        </CardBody>
      </Card>
    </Col>
  );
};

export default DisableTouchSwiping;
